import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import GetRefereeUserDataInFirebase from "../data/Firebase/User/GetReferreUserDataInFirebase";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import paginationFactory from "react-bootstrap-table2-paginator";
import DataNotFoundView from "./DataNotFoundView";
import PaginationView from "./PaginationView";
import { Languages } from "../Utils/Languages";
import { ConfigContext } from "../context/GlobalContext";
import { h } from "@fullcalendar/core/preact.js";

const { SearchBar } = Search;

const ReferralUser = () => {
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const { state, dispatch } = useContext(ConfigContext);
    const [currentPage, setCurrentPage] = useState(1);
    const referees = state?.REFERREUSER || [];
    const totalPages = Math.ceil(referees?.length / itemsPerPage);

    const paginatedData = useMemo(() => {
        const start = (currentPage - 1) * itemsPerPage;
        return referees.slice(start, start + itemsPerPage);
    }, [referees, currentPage, itemsPerPage]);

    const handleSelection = (val) => {
        setItemsPerPage(val);
        setCurrentPage(1)
    };


    const columns = [
        {
            dataField: "id",
            text: "Sr No",
            headerAlign: "center",
            align: "center",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "name",
            text: "User",
            formatter: (cell, row) => (
                <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                        <h6 className="text-md mb-0 fw-medium">{row.name || "Unknown"}</h6>
                        <span className="text-sm text-secondary-light fw-medium">
                            {row.email}
                        </span>
                    </div>
                </div>
            ),
        },
        {
            dataField: "createdAt",
            text: "Registered On",
            formatter: (cell) => new Date(parseInt(cell?.length > 10 ? parseInt(cell) : parseInt(cell) * 1000)).toDateString(),

        },
        {
            dataField: "acceptedAt",
            text: "Accepted On",
            formatter: (cell) => {
                if (!cell) return "—"; // ✅ Show dash if no date
                const timestamp = cell?.length > 10 ? parseInt(cell) : parseInt(cell) * 1000;
                return new Date(timestamp).toDateString();
            },
        },

        {
            dataField: "platform",
            text: "Platform",
            formatter: (cell) => cell || "Website",
        },
        {
            dataField: "status",
            text: Languages[state?.LANGUAGE]?.status,
            headerAlign: "center",
            align: "center",
            formatter: (cell) => (
                <span
                    className={`d-inline-block text-center px-24 py-4 rounded-pill fw-medium text-sm ${cell === "success"
                        ? "bg-success-focus text-success-main"
                        : "bg-danger-focus text-danger-main"
                        }`}
                >
                    {cell}
                </span>
            ),
            sort: true,
        }

    ];

    const paginationOptions = {
        sizePerPage: itemsPerPage,
        showTotal: true,
        hideSizePerPage: true,
    };

    return (
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title mb-3">Referred Users</h5>
                    <ToolkitProvider
                        keyField="userId"
                        data={referees}
                        columns={columns}
                        search
                    >
                        {(props) => (
                            <>
                                {/* ✅ Search + Entries Dropdown */}
                                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-3">
                                    <SearchBar
                                        {...props.searchProps}
                                        placeholder="Search users"
                                        className="form-control w-100 w-sm-auto mb-2 mb-sm-0"
                                    />


                                </div>

                                {/* ✅ Table */}
                                <div className="table-responsive">
                                    {(<BootstrapTable
                                        {...props.baseProps}
                                        bootstrap4
                                        bordered={false}
                                        wrapperClasses={`custom-table-border invoice-table ${localStorage.getItem("theme") === "dark" ? "table-dark" : "table-light"}`}
                                        defaultSorted={[{
                                            dataField: "userId",
                                            order: "asc"
                                        }]}
                                        noDataIndication={() => <DataNotFoundView height={400} />}
                                        rowStyle={{ cursor: "pointer" }}
                                    />)}
                                </div>

                                {paginatedData?.length > 0 && (<div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 mt-3">
                                    <div className="d-flex align-items-center gap-2 entry_per_page">
                                        <div className="dropdown">
                                            <button
                                                className="btn btn-outline-primary-600 not-active px-18 py-6 dropdown-toggle toggle-icon"
                                                type="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                {itemsPerPage}
                                            </button>
                                            <ul className="dropdown-menu shadow-md">
                                                {[5, 10, 15, 20].map((value) => (
                                                    <li key={value}>
                                                        <Link
                                                            className={`dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 ${itemsPerPage == value && "bg-primary-50"}`}
                                                            onClick={() => handleSelection(value)}
                                                        >
                                                            {value}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <span className="text-secondary-light">{Languages[state?.LANGUAGE]?.entries_per_page}</span>
                                    </div>
                                    <div className="ms-auto">
                                        <PaginationView
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            handlePageChange={setCurrentPage}
                                        />
                                    </div>
                                </div>)}

                            </>
                        )}
                    </ToolkitProvider>
                </div>
            </div>
        </div>
    );
};

export default ReferralUser;
